import { type ReactNode, useRef } from 'react';

import { createStore, type Store } from '../../../core/store/store.js';
import { CategoricalBarChartStateContext } from '../contexts/CategoricalBarChartState.context.js';
import { type CategoricalBarChartState, initialState } from '../types/state.js';

export const StoreProvider = ({ children }: { children: ReactNode }) => {
  const storeRef = useRef<Store<CategoricalBarChartState> | null>(null);

  storeRef.current = createStore<CategoricalBarChartState>(initialState);

  return (
    <CategoricalBarChartStateContext.Provider value={storeRef.current}>
      {children}
    </CategoricalBarChartStateContext.Provider>
  );
};
